import React, { useEffect, useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import { FormParser } from "../Components/FormParser/FormParser";
import Masters from "../Components/masters.json";
import { useAuth } from "../Utils/AuthContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig";
import { PopupModal } from "../Components";
import { AudirequireShare } from ".";
import { RiEqualizerLine } from "react-icons/ri";
import { hasRelevantRole } from "../Utils/RoleCheckService";
import { fetchApplicationsList } from "../Utils/ApiHandles";

const PAGE_SIZE = 10;

const AudiRequire = ({ ProfileData }) => {
  const { isLoggedIn, is24Craft } = useAuth();
  const Navigate = useNavigate();

  const [activeCount, setActiveCount] = useState(0);
  const [popupType, setpopupType] = useState("");
  const [Error, SetError] = useState("");
  const [loading, setLoading] = useState(false);
  const [AudiData, setAudiData] = useState([]);
  const [filterShow, setFilterShow] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1020);
  const [loading2, setLoading2] = useState(false);
  const [auditionRequirements, setAuditionRequirements] = useState([]);

  const pageRef = useRef(1);
  const totalPagesRef = useRef(null);
  const observerRef = useRef(null);

  const profile_data = JSON.parse(localStorage.getItem("profile_data"))?.profile_id;
  const frames_24 = localStorage.getItem("frames_24");
  const [searchParams, setSearchParams] = useSearchParams();

  const [params, setParams] = useState({
    requirement_status: searchParams.get("requirement_status") || "live",
    state: searchParams.get("present_state") || "",
    city: searchParams.get("present_city") || "",
    languages: searchParams.get("languages"),
    audition__project_type: searchParams.get("audition__project_type") || "",
    audition__platform: searchParams.get("audition__platform") || "",
    gender: searchParams.get("gender") || "",
  });

  const fetchActiveAuditionCount = async () => {
    try {
      const response = await axiosConfig.get(
        `/accounts/audition-requirements/?approval_status=approved&requirement_status=live&page_size=1`
      );
      setActiveCount(response.data.count);
    } catch (err) {
      console.error("Error fetching active auditions count:", err);
    }
  };

  const handleResize = () => {
    setIsMobile(window.innerWidth < 1020);
  };

  const handleNavigate = () => {
    Navigate(`/auditions/add`);
  };

  const formSubmit = (Data) => {
    setFilterShow(false);
    const datatosend = { ...params, ...Data };

    const filteredParams = Object.keys(datatosend)
      .filter((key) => datatosend[key] !== null && datatosend[key] !== "")
      .reduce((acc, key) => {
        acc[key] = datatosend[key];
        return acc;
      }, {});

    const queryStringParts = [];
    Object.entries(filteredParams).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        value.forEach((val) => queryStringParts.push(`${key}=${val}`));
      } else {
        queryStringParts.push(`${key}=${value}`);
      }
    });

    const queryString = queryStringParts.join("&");
    setSearchParams(queryString);
    setParams(filteredParams);

    axiosConfig
      .get(
        `/accounts/audition-requirements/?page=1&page_size=${PAGE_SIZE}&approval_status=approved&${queryString}`
      )
      .then((response) => {
        pageRef.current = 1;
        totalPagesRef.current = Math.ceil(response.data.count / PAGE_SIZE);
        setAudiData(response.data.results);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error?.response?.data?.error || error.message);
      });
  };

  const GetData = async (status) => {
    setLoading(true);
    const filteredParams = Object.keys(params)
      .filter((key) => params[key] !== null && params[key] !== "")
      .reduce((acc, key) => {
        acc[key] = params[key];
        return acc;
      }, {});

    try {
      const response = await axiosConfig.get(
        `/accounts/audition-requirements/?approval_status=approved&requirement_status=${status}&page=1&page_size=${PAGE_SIZE}`
      );
      pageRef.current = 1;
      totalPagesRef.current = Math.ceil(response.data.count / PAGE_SIZE);
      setAudiData(response.data.results);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (newStatus) => {
    const newParams = { ...params, requirement_status: newStatus };
    setParams(newParams);
    setSearchParams(newParams);
    GetData(newStatus);
  };

  const fetchAuditionList = async () => {
    const response = await fetchApplicationsList();
    setAuditionRequirements(response);
  };

  const HandleDeleteClose = () => {
    GetData(params.requirement_status);
  };

  const requirementprops = {
    HandleDeleteClose,
    setAuditionRequirements,
    auditionRequirements,
    fetchAuditionList,
  };

  useEffect(() => {
    GetData(params.requirement_status);
    fetchActiveAuditionCount();
    fetchAuditionList();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      async ([entry]) => {
        if (
          entry.isIntersecting &&
          !loading2 &&
          pageRef.current < totalPagesRef.current
        ) {
          setLoading2(true);
          pageRef.current += 1;

          try {
            const resp = await axiosConfig.get(
              `/accounts/audition-requirements/?page=${pageRef.current}&page_size=${PAGE_SIZE}&approval_status=approved&requirement_status=${params.requirement_status}`
            );
            setAudiData((prev) => [...prev, ...resp.data.results]);
          } catch (err) {
            console.error("Pagination error:", err);
          } finally {
            setLoading2(false);
          }
        }
      },
      {
        root: null,
        rootMargin: "200px",
        threshold: 0.1,
      }
    );

    const currentTarget = observerRef.current;
    if (currentTarget) observer.observe(currentTarget);

    return () => {
      if (currentTarget) observer.unobserve(currentTarget);
    };
  }, [params.requirement_status, loading2]);

  return (
    <>
      <div className="main-cards">
        <div className="opportunities">
          <div className="opportunty-filter">
            <div className="opportunty_filter_mobilenon">
              <div className="opportunites">
                <h6 className="opp-title">
                  Opportunities{" "}
            
                </h6>
                <p className="opp-quote">Continue your star journey</p>
              </div>
              <div className="Audi-status">
                <div className="auditons-status-btns">
                  <button
                    className={`btn ${
                      params.requirement_status === "live"
                        ? "btn-secondary"
                        : "btn-info"
                    }`}
                    onClick={() => handleStatusChange("live")}
                  >
                    Active
                  </button>
                  <button
                    className={`btn ${
                      params.requirement_status === "closed"
                        ? "btn-secondary"
                        : "btn-info"
                    }`}
                    onClick={() => handleStatusChange("closed")}
                  >
                    Past
                  </button>
                </div>
                <div className="audi-filter">
                  <button className="btn" onClick={() => setFilterShow(true)}>
                    <RiEqualizerLine size={30} className="filter-icon" />
                  </button>
                </div>
              </div>
              <div className="addinformation">
                <div className="btnflx">
                  {hasRelevantRole(frames_24) &&
                    isLoggedIn &&
                    (ProfileData
                      ? ProfileData.id === profile_data
                      : profile_data) && (
                      <div className="btnitem">
                        <button
                          className="btn btn-primary"
                          onClick={handleNavigate}
                        >
                          + Add New
                        </button>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="opportunity-card">
        <div className="row">
          {loading ? (
            <div className="loader-container">
              <img
                src={require("../Components/FormParser/images/loader.gif")}
                alt="Loading..."
              />
            </div>
          ) : (
            <>
              {AudiData.map((Audition, index) => (
                <AudirequireShare
                  key={index}
                  Audition={Audition}
                  index={index}
                  {...requirementprops}
                />
              ))}
              {loading2 && (
                <div className="loader-container">
                  <img
                    src={require("../Components/FormParser/images/loader.gif")}
                    alt="Loading..."
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {popupType !== "" && (
        <PopupModal
          popupType={popupType}
          setpopupType={setpopupType}
          error={Error}
        />
      )}

      <Modal
        size="lg"
        show={filterShow}
        onHide={() => setFilterShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Filters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormParser
            formData={params}
            modelObject={Masters.AuditionFilter}
            formSubmit={formSubmit}
            error={Error}
          />
        </Modal.Body>
      </Modal>

      <div
        ref={observerRef}
        style={{ height: "1px", marginTop: "100px" }}
      ></div>
    </>
  );
};

export { AudiRequire };
